import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import store from "./DAL/store";
import SalesForceContactApp from './SalesForceContactApp/SalesForceContactApp';

const init = () => {
    const $rootRegApp = document.getElementById('contact-form-app');
    if ($rootRegApp) {

        //console.log('ddlsetupList: ',ddlsetupList);
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={store}>
                    <SalesForceContactApp />
                </Provider>
            </React.StrictMode>,
            $rootRegApp
        );
        /*ReactDOM.render(
            <SalesForceSurveyApp sfFormData={sfFormData} phoneCountries={ddlPhoneCounties} setupList={ddlsetupList} />,
            $rootRegApp
        );*/
    }

   /* const $rootCancelApp = document.getElementById('events-cancel-app');
    if ($rootCancelApp) {
        const dataMessage = $rootCancelApp.getAttribute('data-message');
        ReactDOM.render(
            <SalesForceContact2App message={dataMessage}/>,
            $rootCancelApp
        );
    }


    const $rootEventsContacApp = document.getElementById('events-contact-app');
    if ($rootEventsContacApp) {
        const dataUser =getJSONFromHtml(document.getElementById('events-contact-data')) as EventUserRegistration;
        ReactDOM.render(
            <EventsContactApp  dataUser={dataUser} />,
            $rootEventsContacApp
        );
    }
*/

};

init();